export const CONFIGURATION_SETTING_KEYS = {
  IsCustomTilePageActive: 'isCustomTilePageActive',
  IsLoginActive: 'isLoginActive',
  LoginButtonIcon: 'loginButtonIcon',
  LogoutButtonIcon: 'logoutButtonIcon',
  AccountIcon: 'accountIcon',
  PaymentIcon: 'paymentIcon',
  PictureIcon: 'pictureIcon',
  IsRegisterActive: 'isRegisterActive',
  IsDocumentActive: 'isDocumentActive',
  AppButtonActive: 'appButtonActive',
  IsDocumentSupplyActive: 'isDocumentSupplyActive',
  TenantId: 'tenantId',
  ServiceAreaId: 'serviceAreaId',
  IsRelationSearchActive: 'isRelationSearchActive',
  RelationSearchAccuracy: 'relationSearchAccuracy',
  RelationSearchStopLimit: 'relationSearchStopLimit',
  IsRelationSearchLoadAllStopsActive: 'isRelationSearchLoadAllStopsActive',
  IsDirectSaleActive: 'isDirectSaleActive',
  IsOnDemandActive: 'isOnDemandActive',
  IsPaymentProviderActive: 'isPaymentProviderActive',
  IsUicSecurityPortalActive: 'isUicSecurityPortalActive',
  UicTariffAreas: 'uicTariffAreas',
  IsVdvKaActive: 'isVdvKaActive',
  VdvKaTariffAreas: 'vdvkaTariffAreas',
  IsVdvKaMoticsActive: 'isVdvKaMoticsActive',
  IsVouchersActive: 'isVouchersActive',
  IsDirectSaleGuestActive: 'isDirectSaleGuestActive',
  IsDirectSaleAlternatePassengerActive: 'isDirectSaleAlternatePassengerActive',
  DirectSaleAlternatePassengerData: 'directSaleAlternatePassengerData',
  IsDirectSalesFixedPriceActive: 'isDirectSalesFixedPriceActive',
  IsSubscriptionActive: 'isSubscriptionActive',
  SubscriptionServiceArea: 'subscriptionServiceArea',
  IsSubscriptionShibbolethActive: 'isSubscriptionShibbolethActive',
  IsSubscriptionShibbolethUrl: 'isSubscriptionShibbolethUrl',
  SubscriptionReceiverMailAddress: 'subscriptionReceiverMailAddress',
  SubscriptionReceiverName: 'subscriptionReceiverName',
  SubscriptionReceiverCaption: 'subscriptionReceiverCaption',
  IsWalletActiveDirectSale: 'isWalletActiveDirectSale',
  ShowVat: 'showVat',
  VatName: 'vatName',
  PaymentProvider: 'paymentProvider',
  ActivateAccountNotifyTemplate: 'activateAccountNotifyTemplate',
  ChangedPasswordNotifyTemplate: 'changedPasswordNotifyTemplate',
  ForgotPasswordNotifyTemplate: 'forgotPasswordNotifyTemplate',
  OrderConfirmedNotifyTemplate: 'orderConfirmedNotifyTemplate',
  CancellationNotifyTemplate: 'cancellationNotifyTemplate',
  SubscriptionOrderConfirmedNotifyTemplate:
    'subscriptionOrderConfirmedNotifyTemplate',
  ChangeMailAddressNotifyTemplate: 'changeMailAddressNotifyTemplate',
  PersonalDataChangeNotifyTemplate: 'personalDataChangeNotifyTemplate',
  AddressValidationType: 'addressValidationType',
  ExistingCustomerRegistration: 'existingCustomerRegistration',
  MinimumRegistrationAge: 'minimumRegistrationAge',
  SalutationsRegistration: 'salutationsRegistration',
  IsProofOfPurchaseName: 'isProofOfPurchaseName',
  IsJourneyPlannerActive: 'isJourneyPlannerActive',
  JourneyPlannerProvider: 'journeyPlannerProvider',
  JourneyPlannerUrl: 'journeyPlannerUrl',
  JourneyPlannerApi: 'journeyPlannerApi',
  IsJourneyPlannerRedirectActive: 'isJourneyPlannerRedirectActive',
  IsJourneyPlannerRelationInfoWebActive:
    'isJourneyPlannerRelationInfoWebActive',
  OperatorMappings: 'operatorMappings',
  MaxShoppingCartSize: 'maxShoppingCartSize',
} as const;

export type ConfigurationSettingKey =
  (typeof CONFIGURATION_SETTING_KEYS)[keyof typeof CONFIGURATION_SETTING_KEYS];
